/**
 * subscribe-page.js
 * --------------------------------------------------------------
 * Drives the welleco-style /pages/subscribe UI:
 *   • Category tabs   — click / keyboard to switch product panel
 *   • Carousel arrows — scroll one card-width at a time
 *
 * No build step, no framework. Loaded once with `defer` via
 * snippets/subscribe-products.liquid.
 */
(function () {
  // ─────────────────────── TABS ───────────────────────
  function activateTab(container, tab) {
    if (!tab || tab.classList.contains('is-active')) return;
    var targetId = tab.getAttribute('data-target');
    if (!targetId) return;

    container.querySelectorAll('.vv-subscribe-products__tab').forEach(function (t) {
      var isActive = t === tab;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      t.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    container.querySelectorAll('.vv-subscribe-products__panel').forEach(function (p) {
      var isActive = p.id === targetId;
      p.classList.toggle('is-active', isActive);
      if (isActive) {
        p.removeAttribute('hidden');
      } else {
        p.setAttribute('hidden', '');
      }
    });

    tab.focus();
  }

  function moveTabFocus(container, currentTab, direction) {
    var tabs = Array.prototype.slice.call(
      container.querySelectorAll('.vv-subscribe-products__tab')
    );
    if (!tabs.length) return;
    var idx = tabs.indexOf(currentTab);
    var next;
    if (direction === 'first') next = tabs[0];
    else if (direction === 'last') next = tabs[tabs.length - 1];
    else if (direction === 'prev') next = tabs[(idx - 1 + tabs.length) % tabs.length];
    else if (direction === 'next') next = tabs[(idx + 1) % tabs.length];
    activateTab(container, next);
  }

  function bindTabs(container) {
    container.addEventListener('click', function (e) {
      var tab = e.target.closest('.vv-subscribe-products__tab');
      if (!tab || !container.contains(tab)) return;
      e.preventDefault();
      activateTab(container, tab);
    });

    container.addEventListener('keydown', function (e) {
      var tab = e.target.closest('.vv-subscribe-products__tab');
      if (!tab || !container.contains(tab)) return;
      switch (e.key) {
        case 'ArrowLeft':
          e.preventDefault();
          moveTabFocus(container, tab, 'prev');
          break;
        case 'ArrowRight':
          e.preventDefault();
          moveTabFocus(container, tab, 'next');
          break;
        case 'Home':
          e.preventDefault();
          moveTabFocus(container, tab, 'first');
          break;
        case 'End':
          e.preventDefault();
          moveTabFocus(container, tab, 'last');
          break;
      }
    });
  }

  // ─────────────────────── CAROUSEL ARROWS ───────────────────────
  function bindCarousels(container) {
    container.querySelectorAll('.vv-sub-carousel').forEach(function (carousel) {
      var track = carousel.querySelector('.vv-sub-carousel__track');
      var prev = carousel.querySelector('.vv-sub-carousel__arrow--prev');
      var next = carousel.querySelector('.vv-sub-carousel__arrow--next');
      if (!track) return;

      function step() {
        var card = track.querySelector('.vv-sub-card');
        if (!card) return track.clientWidth * 0.9;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }
    });
  }

  // ─────────────────────── FREQUENCY → CTA SYNC ───────────────────────
  // When the user picks a different delivery frequency, mirror that
  // selling_plan_id onto the matching SUBSCRIBE & SAVE button so the
  // global add-to-cart handler sends the right plan.
  function bindFrequencySync(root) {
    var scope = root || document;
    scope.querySelectorAll('.vv-sub-card__freq').forEach(function (select) {
      if (select.dataset.boundFreq === '1') return;
      select.dataset.boundFreq = '1';

      function apply() {
        var targetId = select.dataset.targetCta;
        if (!targetId) return;
        var cta = document.getElementById(targetId);
        if (!cta) return;
        var planId = select.value;
        if (planId) {
          cta.dataset.sellingPlanId = planId;
        } else {
          delete cta.dataset.sellingPlanId;
        }
      }

      // Sync on first paint in case the rendered "selected" option
      // doesn't match the initial CTA attribute.
      apply();
      select.addEventListener('change', apply);
    });
  }

  function init() {
    document.querySelectorAll('.vv-subscribe-products').forEach(function (container) {
      if (container.dataset.bound === '1') return;
      container.dataset.bound = '1';
      bindTabs(container);
      bindCarousels(container);
    });
    bindFrequencySync(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
